import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import Card from "components/card/Card";

interface ProjectManagerInfoProps {
  projectManagers: string[];
}

export const ProjectManagerInfo: React.FC<ProjectManagerInfoProps> = ({ 
  projectManagers 
}) => {
  return (
    <Card p="0" width="fit-content">
      <Text
        fontWeight="400"
        fontSize="12px"
        lineHeight="24px"
        color="#8E8C8C"
      >
        Project Manager
      </Text>
      <Flex alignItems="center" marginTop="5px">
        {projectManagers?.length > 0 ? (
          <Text
            fontWeight="400"
            fontSize={{ md: "17px", sm: "14px" }}
            lineHeight="135%"
            color="#000"
          >
            {projectManagers?.join(", ")}
          </Text>
        ) : (
          <Text
            fontWeight="400"
            fontSize={{ md: "17px", sm: "14px" }}
            lineHeight="135%"
            color="#000"
          >
            Not Assigned
          </Text>
        )}
      </Flex>
    </Card>
  );
};
